import { useEffect, useCallback, useContext } from 'react'
import { useMutation, useQuery } from '@apollo/client'
import AuthContext from 'store/AuthContext'

import { M_LOGIN } from 'graphql/mutations'
import { Q_AUTH_QUERY } from 'graphql/query'

export const useAuth = () => {
  const [call, { data, loading, errors }] = useMutation(M_LOGIN)
  const { refetch } = useQuery(Q_AUTH_QUERY)
  const {
    state: { auth },
    dispatch,
  } = useContext(AuthContext)

  const checkAuth = useCallback(async () => {
    if (refetch()) {
      return await refetch().then(res => {
        const val = JSON.parse(res.data.auth)
        dispatch({
          type: 'setAuthState',
          auth: val,
        })
        console.debug('Current Auth state :', val)
        return val
      })
    } else {
      dispatch({ type: 'doLogout' })
      return false
    }
  }, [refetch, dispatch])

  const doLogin = (username, password) => {
    call({ variables: { username, password } })
      .then(res => {
        localStorage.setItem('refreshExp', res.data.tokenAuth.refreshExpiresIn)
        localStorage.setItem('refreshToken', res.data.tokenAuth.refreshToken)
        localStorage.setItem('token', res.data.tokenAuth.token)
        localStorage.setItem('tokenExp', res.data.tokenAuth.payload.exp)
      })
      .then(res => {
        checkAuth()
      })
      .catch(err => err.response)
  }

  const doLogout = () => {
    dispatch({ type: 'doLogout' })
  }

  useEffect(() => {
    dispatch({ type: 'setAccountActions', doLogin, doLogout })
    checkAuth()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return {
    data,
    loading,
    errors,
    checkAuth,
    auth,
  }
}

export default useAuth
